function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 3h80v80H0z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4 4)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#371447",
  d: "M20.075 18.048l16.61-16.594 16.61 16.594"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11 34)",
  fill: "#E57373"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 17.74,
  cy: 5.343,
  rx: 5.326,
  ry: 5.343
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 31.931,
  cy: 7.771,
  rx: 5.326,
  ry: 5.343
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 6.31,
  cy: 14.664,
  rx: 3.551,
  ry: 3.562
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.31 19.429h.57a5.31 5.31 0 015.31 5.31v7.71H0v-7.71a5.31 5.31 0 015.31-5.31zm39.907 1.214h.57a5.31 5.31 0 015.31 5.31v5.914h-11.19v-5.914a5.31 5.31 0 015.31-5.31z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.115 12.49h1.058a7.08 7.08 0 017.08 7.08v13.124H11.035V19.569a7.08 7.08 0 017.08-7.08z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.475 15.786h1.058a7.08 7.08 0 017.08 7.08v10.43H25.395v-10.43a7.08 7.08 0 017.08-7.08z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 44.667,
  cy: 15.705,
  rx: 3.551,
  ry: 3.562
})), /*#__PURE__*/React.createElement("path", {
  d: "M.544 18.055V68.45h71.542V18.055H.544zm6.402 6.395h59.478v37.974H6.946V24.45z",
  stroke: "#371447",
  fill: "#E57373"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  cx: 36.588,
  cy: 2.029,
  r: 2
})));

function SvgFamilyLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgFamilyLg;